import { useState } from "react";
import { DeviceDto } from "../../types";
import { deleteDevice } from "../../services/deviceService";

export const useDeviceMenu = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedRow, setSelectedRow] = useState<DeviceDto>();
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
  const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const handleMenuClick = (
    event: React.MouseEvent<SVGSVGElement>,
    row: DeviceDto
  ) => {
    setAnchorEl(event.currentTarget as unknown as HTMLElement);
    setSelectedRow(row);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleView = () => {
    setIsUpdateModalOpen(true);
    handleCloseMenu();
  };

  const handleCloseUpdateModal = () => {
    setIsUpdateModalOpen(false);
  };

  const handleDeleteClick = () => {
    setIsDeleteConfirmOpen(true);
    handleCloseMenu();
  };

  const handleDeleteCancel = () => {
    setIsDeleteConfirmOpen(false);
  };

  const handleDeleteConfirm = async (onSuccess: () => void, onError: (e: Error) => void) => {
    if (!selectedRow) return;
    setDeleteLoading(true);
    try {
      const res = await deleteDevice(selectedRow.id);
      if (!res.data.success) throw new Error(res.data.message);
      setIsDeleteConfirmOpen(false);
      onSuccess();
    } catch (e) {
      onError(e as Error);
    } finally {
      setDeleteLoading(false);
    }
  };

  return {
    anchorEl,
    selectedRow,
    handleMenuClick,
    handleCloseMenu,
    handleView,
    isUpdateModalOpen,
    handleCloseUpdateModal,
    isDeleteConfirmOpen,
    deleteLoading,
    handleDeleteClick,
    handleDeleteCancel,
    handleDeleteConfirm,
  };
};
